import Collection from './basic.js';
import Job from '@/models/job.js';
import _ from 'lodash';

class Jobs extends Collection {
    constructor(options) {
        const opts = _.defaults({}, options, {
            baseUrl: '/mtm-gateway-api/v1/services/crawlers-admin/jobs',
            fieldName: 'jobs',
            idField: 'job_id',
            resource: Job
        });

        super(opts);
    }

    selectPage(pageNum) {
        const after = pageNum * this.paginated_params['limit'];
        this.paginated_params['after'] = after;
        this.current_page = pageNum;
        return this.fetch({
            params: {
                sort: "modified_date:desc"
            }
        });
    }
}

export default Jobs;
